"use client";

import { TypedSupabaseClient } from '@lib/utils/supabase';
import { createClient } from '@lib/utils/supabase/client';
import React, { createContext, useContext, ReactNode, useMemo } from 'react';
interface SupabaseContextValue {
  supabase: TypedSupabaseClient;
}
const SupabaseContext = createContext<SupabaseContextValue | undefined>(undefined);
export const SupabaseProvider: React.FC<{
  children: ReactNode;
}> = ({
  children
}) => {
  const supabase = useMemo(() => {
    return createClient();
  }, []);
  return <SupabaseContext.Provider value={{
    supabase
  }} data-sentry-element="SupabaseContext.Provider" data-sentry-component="SupabaseProvider" data-sentry-source-file="supabase-provider.tsx">
      {children}
    </SupabaseContext.Provider>;
};
export const useSupabase = (): SupabaseContextValue => {
  const context = useContext(SupabaseContext);
  if (!context) {
    throw new Error('useSupabase must be used within a SupabaseProvider');
  }
  return context;
};